import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, isEmpty, filter, size } from "lodash";
import clsx from "clsx";

import { fetchGet } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";

import ProfileSurveyDialog from "../../Profiles/ProfileSurvey/ProfileSurveyDialog";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  disabledLink: {
    color: colors.black54,
  },
};

const HspSurveyDialog = (props) => {
  const { classes, item, language, lov } = props;
  const [survey, setSurvey] = React.useState();
  const [openDialog, setOpenDialog] = React.useState(false);

  const fetchSurvey = async () => {
    try {
      let res = await fetchGet(`events/${get(item, ["event_id"])}`);
      setSurvey(res);
    } catch (e) {
      console.log(e);
    }
  };

  const handleClick = () => {
    if (get(item, ["event_id"])) {
      fetchSurvey();
      setOpenDialog(true);
    }
  };

  if (isEmpty(survey)) {
    return (
      <Grid container wrap="nowrap" alignItems="center">
        <Grid item style={{ marginRight: "5px" }}>
          <img
            src={
              size(
                filter(
                  get(item, ["questions", "answers"]),
                  (ans) => get(ans, ["answer"]) === "yes"
                )
              ) > 0
                ? images.verificationIconWarning
                : size(
                    filter(
                      get(item, ["questions", "answers"]),
                      (ans) => get(ans, ["answer"]) !== "no"
                    )
                  ) === 0 && get(item, ["survey_instructions", "completed"])
                ? images.verificationIconOk
                : images.warningTriangleOrange
            }
            height="16px"
            alt="status_icon"
          />
        </Grid>
        <Grid item>
          <span
            className={clsx({
              [classes.link]: get(item, ["event_id"]),
              [classes.disabledLink]: !get(item, ["event_id"]),
            })}
            onClick={handleClick}
          >
            {get(
              filter(
                get(lov, ["eventTypes"]),
                (e) =>
                  get(e, ["id"]) ===
                  (get(item, ["event_type_id"]) === 91
                    ? 81
                    : get(item, ["event_type_id"]))
              ),
              [0, `name_${language}`]
            )}
          </span>
        </Grid>
      </Grid>
    );
  }

  return (
    <ProfileSurveyDialog
      title={get(
        filter(
          get(lov, ["eventTypes"]),
          (e) =>
            get(e, ["id"]) ===
            (get(item, ["event_type_id"]) === 91
              ? 81
              : get(item, ["event_type_id"]))
        ),
        [0, `name_${language}`]
      )}
      surveys={{ lastSurvey: survey }}
      profileId={get(survey, ["profile", "id"])}
      language={language}
      profileName={`${get(survey, ["profile", "firstname"])} ${get(survey, [
        "profile",
        "lastname",
      ])}`}
      onlyOneSurvey
      hide={{ leftCol: true, new: true }}
      forceOpen={openDialog}
      onClose={() => setOpenDialog(false)}
    />
  );
};

export default withStyles(styles)(HspSurveyDialog);
